import React, {useState, useRef} from "react";
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton, Form, FormControl, FormLabel, Input, Textarea, FormErrorMessage, Text, Link, Flex} from "@chakra-ui/react";
import Button from "./Button";

const ContactMeModal = ({ isOpen, onClose }) => {
  const formRef = useRef(null);
  const [isSubmitting, setIsSubmitting] = useState(null);
  const [isSubmitted, setIsSubmitted] = useState(null);
  const [error, setError] = useState(null);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    
    try {
      setIsSubmitting(true);
      const res = await fetch('https://formspree.io/f/mzbnjbjk', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json'
        }
      });
      console.log(res);
      if(res.status === 200){
        setIsSubmitting(false);
        setIsSubmitted(true);
        formRef.current.reset();
      } else {
        setIsSubmitted(false);
        setIsSubmitting(false);
        setError(true);
      }
    } catch (error) {
      console.error('Form submission error:', error);
      setIsSubmitted(false);
      setIsSubmitting(false);
      setError(true);
    }
  };

  setTimeout(() => {
    setError(false); 
  }, 5000);

  setTimeout(() => {
    setIsSubmitted(false); 
  }, 5000);

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay backdropFilter="auto" backdropBlur="md" zIndex={400}/>
      <ModalContent mx={{base:"20px", md: "0px"}}>
      <form ref={formRef} onSubmit={handleSubmit}>
        <ModalHeader>Send me a message</ModalHeader>
        <ModalCloseButton />
        <ModalBody display="flex" flexDirection="column" gap="6">
          <Text>You could also send me a mail at <Link href="mailto:hi@maryojo.me" isExternal textDecoration="underline">hi@maryojo.me</Link></Text>
            <FormControl>
              <FormLabel>What's your name?</FormLabel>
              <Input name="name" placeholder="John Doe" border="none" borderRadius="none"   borderBottom="2px" borderBottomWidth="medium" _focus={{
                borderColor: "#ccc",
              }}/>
            </FormControl>
            <FormControl>
              <FormLabel>What's your email?</FormLabel>
              <Input name="email" placeholder="johndoe@example.com" border="none" borderRadius="none" borderBottom="2px" borderBottomWidth="medium" _focus={{
                borderColor: "#ccc",
              }}/>
            </FormControl>
            <FormControl>
              <FormLabel>Your message</FormLabel>
              <Textarea name="message" placeholder="Enter your message" border="none" borderRadius="none" borderBottom="2px" borderBottomWidth="medium" _focus={{
                borderColor: "#ccc",
              }}/>
            </FormControl>
        </ModalBody>
        <ModalFooter>
        <Flex flexDir="column" justifyContent="right">
        <Button text="Send" type="submit" />
        {isSubmitting && <p>Sending...</p>}
        {error=== true && <p>Something went wrong</p>}
        {isSubmitted && <p>Your message has been sent. Thank you!</p>}
        </Flex>
        </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  );
};

export default ContactMeModal;
